module.exports = __webpack_public_path__ + "static/media/imgop_renewable_heat.6e9ec86a.png";